import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../api";
import { Logo } from "../components/Logo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";

  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 8) {
      setError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (pwd !== confirm) {
      setError("Les deux mots de passe ne correspondent pas.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/password-reset/confirm", {
        token,
        new_password: pwd,
      });
      setDone(true);
      setTimeout(() => nav("/connexion"), 2500);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div
        className="min-h-screen flex items-center justify-center px-6 py-12"
        style={{ backgroundColor: "var(--auprea-cream)" }}
      >
        <div className="w-full max-w-md">
          <Link to="/" className="block mb-10 text-center">
            <Logo size={36} />
          </Link>
          <div className="auprea-card">
            <h1 style={{ fontSize: 26, marginBottom: 12 }}>Lien invalide</h1>
            <p style={{ color: "rgba(35,38,46,0.75)", fontSize: 15, marginBottom: 24 }}>
              Le lien de réinitialisation est incomplet ou a été modifié. Veuillez refaire
              une demande depuis la page « Mot de passe oublié ».
            </p>
            <Link
              to="/mot-de-passe-oublie"
              className="auprea-btn w-full inline-block text-center"
            >
              Nouvelle demande
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6 py-12"
      style={{ backgroundColor: "var(--auprea-cream)" }}
    >
      <div className="w-full max-w-md">
        <Link to="/" className="block mb-10 text-center">
          <Logo size={36} />
        </Link>
        <div className="auprea-card">
          {done ? (
            <>
              <div
                style={{
                  color: "var(--auprea-green)",
                  fontSize: 12,
                  letterSpacing: "0.2em",
                  textTransform: "uppercase",
                  fontWeight: 600,
                  marginBottom: 12,
                }}
              >
                — Mot de passe mis à jour
              </div>
              <h1 style={{ fontSize: 26, marginBottom: 12 }} data-testid="reset-success-title">
                C'est fait
              </h1>
              <p style={{ color: "rgba(35,38,46,0.75)", fontSize: 15, lineHeight: 1.6, marginBottom: 24 }}>
                Votre mot de passe a été réinitialisé avec succès. Vous allez être redirigé(e)
                vers la page de connexion…
              </p>
              <Link
                to="/connexion"
                className="auprea-btn w-full inline-block text-center"
                data-testid="reset-go-to-login"
              >
                Se connecter
              </Link>
            </>
          ) : (
            <>
              <h1 style={{ fontSize: 28, marginBottom: 6 }}>Nouveau mot de passe</h1>
              <p style={{ color: "rgba(35,38,46,0.7)", marginBottom: 28, fontSize: 15 }}>
                Choisissez un mot de passe robuste (8 caractères minimum).
              </p>
              <form onSubmit={submit} className="space-y-5">
                <div>
                  <label className="auprea-label">Nouveau mot de passe</label>
                  <input
                    type="password"
                    className="auprea-input"
                    value={pwd}
                    onChange={(e) => setPwd(e.target.value)}
                    required
                    minLength={8}
                    autoFocus
                    data-testid="reset-password"
                  />
                </div>
                <div>
                  <label className="auprea-label">Confirmer le mot de passe</label>
                  <input
                    type="password"
                    className="auprea-input"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    required
                    minLength={8}
                    data-testid="reset-password-confirm"
                  />
                </div>
                {error && (
                  <div
                    style={{
                      color: "#b53a3a",
                      fontSize: 14,
                      padding: "10px 12px",
                      backgroundColor: "#fcf3f3",
                      border: "1px solid #f0c5c5",
                    }}
                    data-testid="reset-error"
                  >
                    {error}
                  </div>
                )}
                <button
                  type="submit"
                  className="auprea-btn w-full"
                  disabled={loading}
                  data-testid="reset-submit"
                >
                  {loading ? "Mise à jour…" : "Réinitialiser mon mot de passe"}
                </button>
              </form>
              <div className="mt-6 text-center text-sm" style={{ color: "rgba(35,38,46,0.7)" }}>
                <Link to="/connexion" style={{ color: "var(--auprea-blue)" }}>
                  ← Retour à la connexion
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
